/**
 * DevExtreme (esm/__internal/ui/form/constants.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export const WIDGET_CLASS = "dx-widget";
export const FORM_CLASS = "dx-form";
export const FORM_GROUP_CLASS = "dx-form-group";
export const FORM_GROUP_CAPTION_CLASS = "dx-form-group-caption";
export const FORM_GROUP_CUSTOM_CAPTION_CLASS = "dx-form-group-custom-caption";
export const FORM_FIELD_ITEM_COL_CLASS = "dx-col-";
export const FIELD_ITEM_CLASS = "dx-field-item";
export const LAYOUT_MANAGER_ONE_COLUMN = "dx-layout-manager-one-col";
export const FIELD_ITEM_LABEL_CONTENT_CLASS = "dx-field-item-label-content";
export const FORM_LAYOUT_MANAGER_CLASS = "dx-layout-manager";
export const FIELD_ITEM_LABEL_CLASS = "dx-field-item-label";
export const FIELD_ITEM_CONTENT_CLASS = "dx-field-item-content";
export const SINGLE_COLUMN_ITEM_CONTENT = "dx-single-column-item-content";
export const ROOT_SIMPLE_ITEM_CLASS = "dx-root-simple-item";
export const FORM_GROUP_CONTENT_CLASS = "dx-form-group-content";
export const FIELD_ITEM_CONTENT_HAS_GROUP_CLASS = "dx-field-item-has-group";
export const FIELD_ITEM_CONTENT_HAS_TABS_CLASS = "dx-field-item-has-tabs";
export const FORM_GROUP_WITH_CAPTION_CLASS = "dx-form-group-with-caption";
export const FIELD_ITEM_TAB_CLASS = "dx-field-item-tab";
export const GROUP_COL_COUNT_CLASS = "dx-group-colcount-";
export const GROUP_COL_COUNT_ATTR = "group-col-count";
export const FORM_VALIDATION_SUMMARY = "dx-form-validation-summary";
export const FORM_UNDERLINED_CLASS = "dx-form-styling-mode-underlined";
export const SIMPLE_ITEM_TYPE = "simple";